import React, { FunctionComponent } from 'react';
import { InternalLink } from '../../internal-link/internal-link';
import { ILinkProps } from '../navbar';
import styles from './dropdown-menu.module.scss';

export interface IDropDownMenuProps extends React.PropsWithChildren<{}> {
  links: ILinkProps[];
  showMenu: boolean;
}

export const DropDownMenu: FunctionComponent<IDropDownMenuProps> = props => {
  const { showMenu, links } = props;

  return (
    <div
      className={`${styles.dropdownMobileMenu} ${
        showMenu ? styles.dropdownMobileMenuActive : ''
      }`}
    >
      <ul>
        {links.map((link, position) =>
          link.children ? (
            <li className={styles.headerWrapper} key={position}>
              <ul className={styles.sectionClass}>
                <li>
                  <div
                    className={`${styles.listingHeader} ${
                      position === 0 ? styles.listingHeaderActive : ' '
                    }`}
                  >
                    {link.name}
                  </div>
                </li>
                {link.children.map((children, p) => (
                  <li key={p}>
                    <InternalLink
                      url={children.url}
                      className={styles.listingStyle}
                    >
                      {children.name}
                    </InternalLink>
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <li key={position} className={styles.listingSpace}>
              <InternalLink
                url={link.url}
                className={`${styles.sectionClass} ${styles.listingStyleActive}`}
              >
                {link.name}
              </InternalLink>
            </li>
          )
        )}
      </ul>
    </div>
  );
};
